module.exports = __webpack_public_path__ + "static/notifications1-c0659c8075324e972217ae03da6b993c.png";